function _extends() {
  _extends = Object.assign || function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}
import React from 'react';
import PropTypes from 'prop-types';
import defaultProps from '../default-props';
var UndrawPersonalSite = function UndrawPersonalSite(_props) {
  var props = Object.assign({}, _props);
  var primaryColor = props.primaryColor || defaultProps.primaryColor;
  var style = Object.assign({
    height: props.height || defaultProps.height,
    width: '100%'
  }, props.style);
  delete props.primaryColor;
  delete props.height;
  delete props.style;
  return React.createElement("svg", _extends({
    "data-name": "Layer 1",
    width: "1em",
    height: "1em",
    viewBox: "0 0 930.35 441.49",
    style: style
  }, props), React.createElement("path", {
    d: "M902.67 32v349.62A32.38 32.38 0 0 1 870.29 414H132.05a32.38 32.38 0 0 1-32.38-32.38V32a32.4 32.4 0 0 1 32.38-32h738.24a32.4 32.4 0 0 1 32.38 32z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M287.25 76H161.09a13.92 13.92 0 0 0-13.91 13.92v171.17A13.92 13.92 0 0 0 161.1 275h126.15a13.92 13.92 0 0 0 13.93-13.91V89.92A13.92 13.92 0 0 0 287.25 76z",
    fill: primaryColor,
    opacity: 0.3
  }), React.createElement("path", {
    d: "M902.67 32h-803a32.4 32.4 0 0 1 32.38-32h738.24a32.4 32.4 0 0 1 32.38 32z",
    fill: "#e6e6e6"
  }), React.createElement("circle", {
    cx: 130.67,
    cy: 16,
    r: 7,
    fill: "#f2f2f2"
  }), React.createElement("circle", {
    cx: 151.67,
    cy: 16,
    r: 7,
    fill: "#f2f2f2"
  }), React.createElement("circle", {
    cx: 172.67,
    cy: 16,
    r: 7,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 357.67,
    y: 65,
    width: 165,
    height: 33,
    rx: 5.24,
    fill: "#e6e6e6"
  }), React.createElement("rect", {
    x: 687.67,
    y: 65,
    width: 165,
    height: 33,
    rx: 5.24,
    fill: "#e6e6e6"
  }), React.createElement("rect", {
    x: 357.67,
    y: 131,
    width: 495,
    height: 214,
    rx: 7.01,
    fill: "#e6e6e6"
  }), React.createElement("rect", {
    x: 398.17,
    y: 156,
    width: 414,
    height: 10,
    rx: 1.52,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 398.17,
    y: 184,
    width: 414,
    height: 10,
    rx: 1.52,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 398.17,
    y: 212,
    width: 414,
    height: 10,
    rx: 1.52,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 398.17,
    y: 240,
    width: 414,
    height: 10,
    rx: 1.52,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 398.17,
    y: 268,
    width: 414,
    height: 10,
    rx: 1.52,
    fill: "#f2f2f2"
  }), React.createElement("rect", {
    x: 398.17,
    y: 296,
    width: 414,
    height: 10,
    rx: 1.52,
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M156.98 204.4c-5.11 1.94-17 2.16-22.31 2.15h-2.6l-3.39-6.9 3.39-5.76s3.11-.85 7.24-1.6c6.1-1.1 14.44-2 18.42.51 6.67 4.12 5.92 9.07-.75 11.6z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M134.67 206.55h-2.6l-3.39-6.9 3.39-5.76s3.11-.85 7.24-1.6c-3.35 2.46-11.41 7.8-4.64 14.26z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M78.52 121.8l1.5-1.73s7.7 12.2 8.51 16.8 1.84 9.89 1.84 9.89 2 6 3.22 8.63 2.42 5.18 2.53 6.33-.46 3.68 2 5.29 3 6 3 6 8.74 8.52 13.34 8.75 17.84 2.53 17.38 4.83 5.52 3.68 7.93 4.25-15.53 7.48-5.06 16.34c0 0-6.67 1.38-7.36 3s-7.71-.92-7.71-.92-1.49-3.56-6.67-3.79-7.82-2.54-7.82-2.88-5.18-3.22-8.06-4-6.67-1.15-6.79-1.95-17.25-74.78-17.25-74.78z",
    fill: "#4c4981"
  }), React.createElement("path", {
    d: "M78.52 121.8l1.5-1.73s7.7 12.2 8.51 16.8 1.84 9.89 1.84 9.89 2 6 3.22 8.63 2.42 5.18 2.53 6.33-.46 3.68 2 5.29 3 6 3 6 8.74 8.52 13.34 8.75 17.84 2.53 17.38 4.83 5.52 3.68 7.93 4.25-15.53 7.48-5.06 16.34c0 0-6.67 1.38-7.36 3s-7.71-.92-7.71-.92-1.49-3.56-6.67-3.79-7.82-2.54-7.82-2.88-5.18-3.22-8.06-4-6.67-1.15-6.79-1.95-17.25-74.78-17.25-74.78z",
    fill: "#192534"
  }), React.createElement("path", {
    d: "M60.6 441.05c-15.18 2.85-17.95-8.8-17.95-8.8s-1.89-10.36-2.58-11.13a1.24 1.24 0 0 1-.12-1 13.45 13.45 0 0 1 2.23-4.87c.95-1.12.17-5.78.17-5.78l17.6-4.49a27.18 27.18 0 0 1 1.73 5.18c.17 1.64 2.76 9.06 2.5 10.09s1.12 4.23 1.29 5.87 2.33 4.06 2.51 4.92a20.37 20.37 0 0 0 1 2.27 23.33 23.33 0 0 1 1.12 3.51c.77 3.62-9.5 4.23-9.5 4.23z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M60.6 441.05c-15.18 2.85-17.95-8.8-17.95-8.8s-1.89-10.36-2.58-11.13a1.24 1.24 0 0 1-.12-1l3.65 10.48s3 6.3 14.24 5.35c6.38-.54 9.53-1.72 11.05-2.65a23.33 23.33 0 0 1 1.12 3.51c.86 3.63-9.41 4.24-9.41 4.24z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M48.78 424.65s3.8.09 4.06-3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M114.79 322.67c-1.9 2.84-4.06 15.27-4.06 15.27a13 13 0 0 0-1.38 5.26c.09 2.42-1.38 6.82-1.38 6.82l-4.79 17.86s.52 4.75-1.29 8.11-1.64 2.33-.78 8.2-1 11.3-4.14 13 1.38 5.78 1.38 5.78-19.85 5.35-24 2.07 2.16-19.5 2.16-19.5-1-13.64-.35-15.62 3.63-18.9 3.63-18.9 1.81-7.68 1.12-9 .43-5 .43-5 2.93-4.15 2.67-5.44.87-3.62.87-3.62-8.8-13.46-8-16-.34-6.55-.34-6.55-1.11-1.91-2.45-4.19c-1.64-2.8-3.62-6.16-4.28-7.2-.85-1.34-2.89-7-4-10.26-.48-1.39-.8-2.34-.8-2.34s-1.39 25.37-2.59 28-3 23-3 23a14.41 14.41 0 0 0-.87 5.7c.18 3.19-2.76 17.08-2.76 17.08s-1.29 9.84-.43 12.43.17 21.65.17 21.65 4.75 3.71 6 6.56-.17 10.61-.17 10.61-13.81 6.91-19.94 5.1-3.62-12.26-3.62-12.26-4.14-6.9-4.14-9.57a108.36 108.36 0 0 0-1.47-10.88c-5.26-9.66-3.19-33.13-4.05-35s1.81-9 4-12.16 1.3-11.82 0-14.33 1.3-11.13 1.3-11.13-2.5-16.74-2.42-19.33-2.15-10.26-2.15-10.26-2.25-4-1.73-5.18-1.73-4.31-1.12-5.69-.52-5.61-1.64-8.12a48.29 48.29 0 0 1-1.84-7.94c-.53-3-.92-5.6-.92-5.6l14.24-11.48 35.32-9.27 13.38-4.31 13 20.53s1.34 2.15 2.53 4.63c1 2.13 1.94 4.51 1.78 6a8.29 8.29 0 0 0 1.21 5.35s7.77 24.59 7.59 31.66 2.76 22.61 2.76 22.61 3.26 10 1.36 12.85z",
    fill: "#192534"
  }), React.createElement("path", {
    d: "M62.23 122.66c-.55-.23-38.09-15.73-32.92-18.81 3.07-1.83 6.85-9.58 9.43-15.65 1.81-4.23 3-7.65 3-7.65s30.13-5.35 19.35 13.12a34 34 0 0 0-3.8 9.09c-3.05 12.58 4.68 19.67 4.94 19.9z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M61.12 93.67a34 34 0 0 0-3.8 9.09 21 21 0 0 1-17.79-12.5 20.38 20.38 0 0 1-.79-2.06c1.81-4.23 3-7.65 3-7.65S71.9 75.2 61.12 93.67z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M79.84 81.07a21.05 21.05 0 0 1-40.31 8.5 20.81 20.81 0 0 1-1.79-8.5 21.05 21.05 0 0 1 41.28-5.83 20.79 20.79 0 0 1 .82 5.83z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M100.18 244.2c-2.2 2-3.05 5.82-3.05 5.82s-10.35 7.07-9.66 2.58-5.35-22.6-5.35-22.6l.69 24.67s-33.14-1.55-35.55-4-16.57-7.08-16.57-7.08-4.33 3.48-8.31 6.12c-.53-3-.92-5.6-.92-5.6l14.24-11.48 35.48-9.28 13.38-4.31 13 20.53s1.4 2.18 2.62 4.63z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M101.24 242.25c-2.76 1.73-3.8 6.38-3.8 6.38s-10.35 7.08-9.66 2.59-5.35-22.6-5.35-22.6l.69 24.67s-33.13-1.55-35.55-4-16.56-7.07-16.56-7.07-12.26 9.84-14.5 9 4-17.6 4-17.6l6.38-98s-1.72-29.16.87-30.2a3.59 3.59 0 0 0 1.08-.68c1.71-1.53 2.22-4.64 2.37-7.26.17-3.1 4.31-1.55 4.31-1.55l-2.41 3.11 21.38 13 .19.11a24.43 24.43 0 0 1 2.57-1.16c1.89-.73 4.41-1.42 6.06-.74a5.88 5.88 0 0 1 2.26 2 25.56 25.56 0 0 1 2.91 5.9l7.7 13.14s4 17.43 4 18.12 1.21 16.56 2.59 18.29 2.76 10.35 2.24 12.94.86 12.26.86 12.26c5.7 4.65 8.63 20.53 8.63 20.53s9 17.78 9.66 19.85-.16 7.24-2.92 8.97z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M54.46 112.75c-2.1 3.11-8.15 7.48-8.15 7.48l-17.5-14.78c1.71-1.53 2.22-4.64 2.37-7.25.17-3.11 4.31-1.56 4.31-1.56l-.5.65a2.78 2.78 0 0 0 .75 4.08z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M54.46 112.02c-2.1 3.11-8.15 7.47-8.15 7.47l-17.5-14.74c1.71-1.53 2.22-4.64 2.37-7.26.17-3.1 4.31-1.55 4.31-1.55l-.5.65a2.78 2.78 0 0 0 .75 4.08z",
    fill: "#fff"
  }), React.createElement("path", {
    d: "M62.55 114.35c-2.26 2.7-5.46 5.76-5.31 4.23s-1.91-4.93-3.23-6.45a9.52 9.52 0 0 1 6.27.18 5.68 5.68 0 0 1 2.27 2.04z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M62.89 113.31c-2.26 2.7-5.46 5.77-5.31 4.23s-1.7-4-3-5.54c1.89-.73 4.41-1.41 6.06-.73a5.81 5.81 0 0 1 2.25 2.04z",
    fill: "#fff"
  }), React.createElement("circle", {
    cx: 57.23,
    cy: 126.28,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("circle", {
    cx: 67.7,
    cy: 163.56,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("circle", {
    cx: 79.55,
    cy: 201.29,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("circle", {
    cx: 79.9,
    cy: 242.36,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("circle", {
    cx: 63.33,
    cy: 143.88,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("circle", {
    cx: 72.65,
    cy: 182.19,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("circle", {
    cx: 81.74,
    cy: 219.81,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("circle", {
    cx: 79.67,
    cy: 246.96,
    r: 1.38,
    fill: "#192534"
  }), React.createElement("path", {
    d: "M28.82 105.58s.23-2.08-2.76 1.49-8.63 6.67-8.63 6.67-12.77 9-13.46 13.12-4.83 22.09-2.65 28.07 18.86 34.63 18.86 34.63-4.37 5.18-3.33 11.27 2.3 14.5 1.72 16.34.69 6.44-1.26 8.05-4 4.37 2.07 8.06c0 0 1.15 3.1.11 3.79s15.3 7.83 21.74 4 18.07-34.17 18.3-41-3.57-29.22-5.64-34.51-8.28-25.89-10.93-30.49-14.14-29.49-14.14-29.49z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M28.18 105.58s.23-2.08-2.76 1.49-8.63 6.67-8.63 6.67-12.77 9-13.46 13.12-4.83 22.09-2.65 28.07 18.87 34.63 18.87 34.63-4.37 5.19-3.37 11.27 2.31 14.5 1.73 16.34.69 6.44-1.26 8.05-4 4.37 2.07 8.06c0 0 1.15 3.1.11 3.79s15.3 7.83 21.74 4 18.07-34.17 18.3-41-3.57-29.22-5.64-34.51-8.3-25.81-10.95-30.42-14.1-29.56-14.1-29.56z",
    fill: "#192534"
  }), React.createElement("path", {
    d: "M23.53 125.13s9.89 10.93 9.55 18.18c0 0 .1-11.73-9.55-18.18zM37.18 143.08c0 .35 6.67 25.2 6.33 28.3s1.95 12.31 1.95 12.31l3.11-.8s-2.42-12.77-2.88-17.49-8.51-22.32-8.51-22.32zM39.86 213.95c-.23.34-15.76 17.95-11.39 19.21s11.39-19.21 11.39-19.21zM27.09 209.46c-.34.23-6.21 12.66-6.9 9.32s5.06 9.09 6-.11zM56.92 109.49s6.41-3.91 14.47 6.09c0 0 5.86 3.34 7.59 4.15s3.68 22.2 3.68 22.2 3.8 9.2 2.76 14.5 3 23.46 3 23.46 6.68 32.68 6.45 33.6-6.8-10.24-6.69-15.74-5.52-22.78-6.32-23.82-6.33-30.6-6.33-30.6-4.49-12.58-7.35-16.7-6.45-12-7.94-13.35a15.2 15.2 0 0 0-3.57-2.3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M56.83 109.49s7.19-3.91 15.25 6.09c0 0 5.86 3.34 7.59 4.15s3.68 22.2 3.68 22.2 3.8 9.2 2.76 14.5 3 23.46 3 23.46 6.68 32.68 6.45 33.6-6.79-10.24-6.68-15.76-5.52-22.78-6.32-23.82-6.33-30.6-6.33-30.6-4.49-12.54-7.36-16.68-6.45-12-7.94-13.35a14.23 14.23 0 0 0-4.26-2.3z",
    fill: "#192534"
  }), React.createElement("path", {
    d: "M78.89 267.96c-2 4.38-3.71 26.37-4.86 33.35-1.64-2.8-3.62-6.16-4.28-7.2-.85-1.34-2.89-7-4-10.26 1.3-3.16 4.89-12.22 4.89-15.54 0-4.06 6.56-9.15 6.56-9.15a7.61 7.61 0 0 1 1.69 8.8zM34.89 335.52s15.18-6.47 19.67-1.9-19.67 1.9-19.67 1.9zM43.43 338.11s-15.36 8.63-10.09 10.1 10.09-10.1 10.09-10.1zM89.33 330.6s-6.55.44-4.05 1.73 4.05-1.73 4.05-1.73zM97.53 332.59c-.09.43-19.07 6.56-15.36 9.32s15.36-9.32 15.36-9.32zM37.18 385.4c2.85-.44 18.73-7.77 12.51-2.51a12.37 12.37 0 0 1-12.51 2.51zM44.98 391.18s1.38 5.35 6.65 4.66-6.65-4.66-6.65-4.66zM40.58 402.05c.95-.26 12.26-5.44 12.51-3s-10.78 6.64-11.64 5.35a4.62 4.62 0 0 1-.87-2.35zM77.18 395.84c1.38-.09 14.32-4.23 16.91-.52zM88.9 398.25s2.25-2 4.49-1-4.49 1-4.49 1zM60.26 419.65a3.86 3.86 0 0 0 2.93 3z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M126.09 427.75c-.86 3.54-12.94 3.88-18.72 2.93s-17.78-4.4-17.78-4.4-12.59-1.2-16.3-2.76-.78-5.52-.78-5.52v-.37c-.09-1.44-.34-6.68.55-8.09 1-1.63.43-7 .43-7s17.86 3.45 18.2 1.81 3.11-4 4.4-4.49 2.25 4.32 2.25 4.32 8.11 6.9 8.63 9.4 6.21 3.8 6.21 3.8 8.63 2.41 10.87 3.62a4.19 4.19 0 0 1 2.38 3.35 9.32 9.32 0 0 1-.34 3.4z",
    fill: "#3f3d56"
  }), React.createElement("path", {
    d: "M126.09 427.75c-.86 3.54-12.94 3.88-18.72 2.93s-17.78-4.4-17.78-4.4-12.59-1.2-16.3-2.76-.78-5.52-.78-5.52v-.37l18.06 4s8.89 3.8 14.58 3.8c5 0 16.11 2 21.28-1a9.32 9.32 0 0 1-.34 3.32z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M101.67 414.13s-.86 5.69-4.31 7.59zM79.02 75.24a6.11 6.11 0 0 1-1 .43c-1.62.43-3.2-.66-4.64-1.53s-3.42-1.52-4.67-.39c-1.62 1.47-.44 4.63-2.11 6.05-1.06.9-2.74.59-3.92 1.33s-1.53 2.36-1.83 3.76-.89 3-2.26 3.41-2.65-.49-4-.44c-.28 0-.6.05-.79-.16a.83.83 0 0 1-.14-.62 13.26 13.26 0 0 0-.43-5 4.8 4.8 0 0 0-3.51-3.29c-2.42-.37-4.46 1.75-5.89 3.75a61.53 61.53 0 0 0-4.08 6.57 4.15 4.15 0 0 0-.2.45 20.81 20.81 0 0 1-1.79-8.5 21.05 21.05 0 0 1 41.28-5.83z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M43.81 82.2c1.43-2 3.46-4.11 5.89-3.74a4.74 4.74 0 0 1 3.48 3.29 13.08 13.08 0 0 1 .44 5 .85.85 0 0 0 .14.63c.19.2.51.17.79.16 1.35 0 2.7.83 4 .44s2-2 2.27-3.41.61-3 1.83-3.76 2.85-.43 3.92-1.34c1.66-1.42.49-4.57 2.11-6.05 1.25-1.12 3.24-.48 4.67.39s3 2 4.64 1.53a15.42 15.42 0 0 0 1.57-.67c2.56-1 5.88.68 8-1.07a6.07 6.07 0 0 0 1.59-2.76 17.35 17.35 0 0 0 1.17-4.4 5.91 5.91 0 0 0-1.17-4.28c-1.37-1.62-3.68-2-5.43-3.21a13.32 13.32 0 0 1-3.47-4.09 15.28 15.28 0 0 0-3.37-4.19 4.94 4.94 0 0 0-5.07-.79 5.47 5.47 0 0 1-1.66.78 3.39 3.39 0 0 1-1.83-.5c-6-2.82-12.95-2.32-19.51-1.48a25.54 25.54 0 0 0-7.69 1.86 9.23 9.23 0 0 0-5.18 5.68c-.54 2-.13 4.23-.77 6.22-.44 1.36-1.34 2.52-1.85 3.85-1.39 3.64.28 7.64 1 11.47.77 4.19.38 8.72 2.16 12.68.35.78.74 2.14 1.62 1.63.65-.38 1.28-2.59 1.65-3.28a62.55 62.55 0 0 1 4.06-6.59z",
    fill: "#192534"
  }), React.createElement("path", {
    d: "M5.93 149.64l-3.11 8.86s7.36 27.38 10.81 33.13 8.55 13.12 8.55 13.12a31.57 31.57 0 0 0 18.4 2.31c9.9-2 38.77-7.14 38.77-7.14a3.85 3.85 0 0 0 3.69-1.38c1.26-1.84 7.82-2.76 7.82-2.76s7.59-11-1.73-15.64c0 0-1.15 2.53-6.09.8s-6.45 1.38-6.45 1.38-8 1.61-12.54 1-15.64-.81-16.79-1.73a1.47 1.47 0 0 0-2.08.16 12.68 12.68 0 0 1-3.69-2.08c-.92-1-2.18 1.16-2.18 1.16s-1.61-.93-1.15-2.08-1.5-5.52-1.5-5.52a11.12 11.12 0 0 1-.34-5.17c.57-2.31-2.88-10.59-2.88-10.59a14.71 14.71 0 0 1 .46-4.14c.58-2.07-4.37-6.21-4.37-6.21s-4.83-23.47-15.07-15.76-8.53 18.28-8.53 18.28z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M80.02 186.68c-.12.81-2.65 4-1.73 4.6s2.42.23 1 2.08-1.26 4.6-.34 4.25 2.42-4.48 2.42-6.1a18.09 18.09 0 0 0-1.35-4.83z",
    opacity: 0.1
  }), React.createElement("g", {
    opacity: 0.1
  }, React.createElement("path", {
    d: "M53.18 79.75a4.78 4.78 0 0 0-3.5-3.28c-2.43-.37-4.46 1.75-5.89 3.75a61.53 61.53 0 0 0-4.08 6.57c-.37.69-1 2.89-1.65 3.27-.88.52-1.27-.85-1.62-1.63-1.78-3.95-1.39-8.49-2.16-12.68a71.57 71.57 0 0 1-1.48-7.39c-.27 3 .91 6.17 1.48 9.23.77 4.19.38 8.73 2.16 12.69.35.77.74 2.14 1.62 1.62.65-.38 1.28-2.58 1.65-3.27a61.53 61.53 0 0 1 4.08-6.57c1.43-2 3.46-4.12 5.89-3.75a4.78 4.78 0 0 1 3.5 3.28 9.17 9.17 0 0 1 .47 2.59 12 12 0 0 0-.47-4.43zM89.18 68.86a6.07 6.07 0 0 1-1.59 2.76c-2.1 1.76-5.42.1-8 1.08a15.34 15.34 0 0 1-1.57.66c-1.62.44-3.2-.65-4.64-1.52s-3.42-1.52-4.67-.39c-1.62 1.47-.44 4.62-2.11 6.05-1.07.9-2.74.59-3.92 1.33s-1.53 2.36-1.83 3.76-.89 3-2.27 3.41-2.64-.49-4-.44c-.28 0-.6.05-.79-.16a.59.59 0 0 1-.1-.17v1.39a.83.83 0 0 0 .14.62c.19.21.51.17.79.16 1.35 0 2.7.83 4 .44s2-2 2.27-3.4.61-3 1.83-3.77 2.85-.43 3.92-1.33c1.67-1.42.49-4.58 2.11-6 1.25-1.13 3.24-.48 4.67.39s3 2 4.64 1.53c.55-.15 1-.47 1.57-.67 2.56-1 5.88.68 8-1.08a6.07 6.07 0 0 0 1.55-2.76 17.39 17.39 0 0 0 1.17-4.39 7.21 7.21 0 0 0 0-1.54 17.89 17.89 0 0 1-1.17 4.04z"
  })), React.createElement("rect", {
    x: 106.67,
    y: 62,
    width: 154,
    height: 199,
    rx: 13.92,
    fill: primaryColor
  }), React.createElement("circle", {
    cx: 183.66,
    cy: 181,
    r: 37,
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M238.64 261H128.7a32.45 32.45 0 0 1 32.41-31h45.12a32.45 32.45 0 0 1 32.41 31z",
    fill: "#f2f2f2"
  }), React.createElement("path", {
    d: "M88.41 181.39s13.69-9 20.31-4.54 17.43 10.7 6.79 15.24-25.33 3.66-25.33 3.66z",
    fill: "#fec2be"
  }), React.createElement("path", {
    d: "M5.24 149.64l-3.06 8.86s7.36 27.38 10.81 33.13 8.47 13.12 8.47 13.12a31.57 31.57 0 0 0 18.4 2.31c9.9-2 38.77-7.14 38.77-7.14a3.85 3.85 0 0 0 3.69-1.38c1.26-1.85 7.86-2.79 7.86-2.79s7.59-11-1.73-15.64c0 0-1.15 2.53-6.09.8s-6.45 1.38-6.45 1.38-8.05 1.61-12.54 1-15.64-.81-16.79-1.73a1.47 1.47 0 0 0-2.07.12 12.68 12.68 0 0 1-3.69-2.08c-.92-1-2.18 1.16-2.18 1.16s-1.61-.93-1.15-2.08-1.5-5.52-1.5-5.52a11.12 11.12 0 0 1-.34-5.17c.57-2.31-2.88-10.59-2.88-10.59a14.71 14.71 0 0 1 .46-4.14c.58-2.07-4.37-6.21-4.37-6.21s-4.83-23.47-15.07-15.76-8.55 18.35-8.55 18.35z",
    fill: "#192534"
  }), React.createElement("path", {
    d: "M875.95 420.64c3-5.51-.4-12.27-4.28-17.18s-8.61-10-8.51-16.29c.14-9 9.7-14.31 17.33-19.08a85.2 85.2 0 0 0 15.56-12.51 23 23 0 0 0 4.78-6.41c1.58-3.51 1.53-7.52 1.43-11.37q-.49-19.26-1.9-38.49",
    fill: "none",
    stroke: "#3f3d56",
    strokeMiterlimit: 10,
    strokeWidth: 4
  }), React.createElement("path", {
    d: "M914.87 298.61a14 14 0 0 0-7-11.5l-3.14 6.22.09-7.53a13.86 13.86 0 0 0-4.62-.55 14 14 0 1 0 14.68 13.36zM889.84 393.6a14 14 0 0 1-26.5-5.75 13.87 13.87 0 0 1 .91-5.7 14 14 0 0 1 26.27.15l-8.77 7.14 9.64-2.24a13.81 13.81 0 0 1-1.55 6.4zM882.91 366.35a14 14 0 0 1-4.46-27.53l-.07 5.78 3.18-6.29a14.015 14.015 0 1 1 1.31 28zM916.98 343.68a14.016 14.016 0 1 1-1.32-28 13.88 13.88 0 0 1 7.52 1.78l-2.48 6.79 5.11-4.9a14 14 0 0 1 4.53 9.69 13.4 13.4 0 0 1-.36 3.87 14 14 0 0 1-13 10.77z",
    fill: "#57b894"
  }), React.createElement("path", {
    d: "M912.98 302.35c-3.24.36-6.39 1.36-9.64 1.57s-6.82-.58-8.88-3.11c-1.11-1.36-1.66-3.08-2.59-4.57a10.06 10.06 0 0 0-3.54-3.32 14 14 0 1 0 26.24 9.31c-.53.03-1.06.06-1.59.12zM916.98 343.68a14 14 0 0 1-13.35-20 10.27 10.27 0 0 1 2.82 2.83c1 1.5 1.6 3.25 2.78 4.63 2.19 2.57 5.92 3.42 9.31 3.26s6.65-1.12 10-1.43c.47 0 .94-.07 1.41-.08a14 14 0 0 1-12.97 10.79zM882.91 366.35a14 14 0 0 1-13.47-19.76 11.24 11.24 0 0 1 3 2.86c1.09 1.53 1.77 3.31 3 4.73 2.36 2.63 6.34 3.56 9.93 3.48s6.82-.93 10.28-1.2a14 14 0 0 1-12.74 9.89zM889.84 393.6a14 14 0 0 1-26.5-5.75 13.87 13.87 0 0 1 .91-5.7 14.06 14.06 0 0 1 3.08 2.75c1.33 1.63 2.21 3.47 3.76 5 2.87 2.81 7.5 4 11.62 4.08a60.15 60.15 0 0 0 7.13-.38z",
    opacity: 0.1
  }), React.createElement("path", {
    d: "M854.79 414.29s11.08-.34 14.41-2.71 17-5.22 17.87-1.41 16.65 19 4.14 19.06-29.06-1.94-32.39-4-4.03-10.94-4.03-10.94z",
    fill: "#656380"
  }), React.createElement("path", {
    d: "M891.44 427.91c-12.51.1-29.06-1.95-32.4-4-2.53-1.55-3.54-7.09-3.88-9.65h-.37s.7 8.94 4 11 19.89 4.08 32.39 4c3.61 0 4.86-1.31 4.79-3.21-.47 1.12-1.85 1.84-4.53 1.86z",
    opacity: 0.2
  }));
};
UndrawPersonalSite.propTypes = {
  height: PropTypes.string,
  primaryColor: PropTypes.string
};
export default UndrawPersonalSite;